'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var alloyInput_module = require('./alloy-input.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var ErrorMessage = function (_a) {
    var children = _a.children, errorClassName = _a.errorClassName, fieldName = _a.fieldName, inputRef = _a.inputRef, onShow = _a.onShow, errorId = _a.errorId, props = tslib.__rest(_a, ["children", "errorClassName", "fieldName", "inputRef", "onShow", "errorId"]);
    react.useEffect(function () {
        if (onShow) {
            onShow(fieldName, inputRef);
        }
    }, [fieldName, inputRef, onShow]);
    return (jsxRuntime.jsx("p", tslib.__assign({ id: errorId, className: cx__default.default("".concat(errorClassName, " exclude-global ").concat(alloyInput_module.default['error-message'])), "aria-live": "assertive" }, props, { children: children })));
};
var ErrorMessage$1 = ErrorMessage;

exports.default = ErrorMessage$1;
//# sourceMappingURL=ErrorMessage.js.map
